<template>
    <v-container grid-list-md>
        <v-layout row align-center justify-center mt-4 v-if="loading">
            <tile :loading="true" color="primary"></tile>
        </v-layout>

        <form v-on:submit.prevent="update" v-if="! loading">

            <v-layout row wrap>
                <!--
                <v-flex xs6 sm6 md4>
                    <v-text-field
                            v-validate="''"
                            v-model="data.name"
                            :error-messages="errors.collect('data.name')"
                            label="Name"
                            data-vv-name="data.name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 md4>
                    <v-text-field
                            v-validate="'required|email'"
                            v-model="data.email"
                            :error-messages="errors.collect('data.email')"
                            label="E-mail"
                            data-vv-name="data.email"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>
            -->
                <v-flex xs4 sm4 md4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.company_name"
                            :error-messages="errors.collect('data.company_name')"
                            label="Company name"
                            data-vv-name="data.company_name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>
                <!--
                <v-flex xs12 sm12 md12>
                    <v-text-field
                            v-validate="''"
                            v-model="data.vat"
                            :error-messages="errors.collect('data.vat')"
                            label="Vat"
                            data-vv-name="data.vat"
                    ></v-text-field>
                </v-flex>
                -->

                <v-flex xs4 sm4 md4>
                    <v-autocomplete
                            v-on:change="getSelectStates"
                            :items="countries"
                            item-text="name"
                            label="Country"
                            item-value="id"
                            v-model="data.country"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs4 sm4 md4>
                    <v-autocomplete
                            :items="states"
                            item-text="name"
                            label="State"
                            item-value="id"
                            v-model="data.state"
                            browser-autocomplete="off"
                    ></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm12 md12>
                    <v-textarea
                            solo
                            name="input-7-4"
                            label="Notes"
                            v-model="data.notes"
                            browser-autocomplete="off"
                    ></v-textarea>
                </v-flex>

                <v-flex>
                    <v-btn large color="primary" class="text--white" type="submit">Save</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    export default {
        props: ['id'],
        data : function() {
            return {
                data : {
                    email : '',
                    company_name : '',
                    shipping_address: '',
                    billing_data: '',
                    country: '',
                    state: '',
                    notes: '',
                    name: ''
                },
                loading: true,
                error : false,
                message_error : null,
                dictionary: {
                    custom: {
                        "data.email": {
                            required: 'The email field is required.',
                            email: () => 'The email field must be a valid email'
                        },
                        "data.company": {
                            required: 'The company name field is required.'
                        },
                        "data.shipping": {
                            required: 'The shipping address field is required.'
                        }
                    }
                },
                countries: null,
                states: null
            }
        },
        created: function () {
            this.getSelectCountry();
            this.getClient();
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods: {
            getClient() {
                this.$store.dispatch('getClient', {
                    id: this.id
                }).then((res) => {

                    this.data = res.data;

                    this.getSelectStates();

                    this.loading = false;

                }).catch((error) => {

                });
            },
            getSelectCountry () {
                this.$store.dispatch('getSelectCountry').then((res) => {

                    this.countries = res.data;

                }).catch((error) => {

                });
            },
            getSelectStates () {
                this.$store.dispatch('getSelectState', {
                    id: this.data.country
                }).then((res) => {

                    this.states = res.data;

                }).catch((error) => {

                });
            },
            update : function() {

                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.error_login = false;
                        this.message_error_login = '';

                        //dispatch the login and catch the response with the promise declared in vuex Authmodule
                        this.$store.dispatch('updateClient', {
                            id: this.id,
                            data : this.data
                        }).then((res) => {
                            this.getClient();

                        }).catch((error) => {
                            //if incorrect we show a message
                            this.error_login = true;
                            this.message_error_login = error.data.message;
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/clients/view/DataComponent.vue